import {
	PAYMENT_TYPE_CONFIG,
	DEAL_TYPE_CONFIG,
	DEFAULT_DISPLAY_INDEX
} from '../constants';

export const capitalizeFirst = (str) =>
	str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

export const getConfigForLabel = (label) => {
	const configKey = DEAL_TYPE_CONFIG[label] || `${label}Offers`;
	return {
		configKey,
		displayIndex:
			PAYMENT_TYPE_CONFIG[configKey]?.displayIndex ??
			DEFAULT_DISPLAY_INDEX
	};
};

export const sortByDisplayIndex = (a, b) =>
	a.displayIndex - b.displayIndex;

export const markPositions = (payments) =>
	payments.map((payment, index) => ({
		...payment,
		firstItem: index === 0,
		lastItem: index === payments.length - 1
	}));
